
































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Api from '@/common/api';
import * as PleasedApi from '@/common/api/api.pleased';
import { BottomWrapper } from '../BottomWrapper.vue';
import { namespace } from 'vuex-class';
import { isEmailValid, combinedDescription } from '@/common/utils';
import waiting from '@/components/loading/waiting';
import { DynamicFieldData, FormField, VisitorInfoFilled } from '@/common/types';
import { MAX_DESCRIPTION_CHAR_NUM, MIN_DESCRIPTION_CHAR_NUM } from '@/common/config';
import { ConnectToAgent } from '@/common/bot/types';

const userModule = namespace('user');

interface TicketForm {
  name?: string,
  email?: string | null,
  subject?: string,
  description?: string,
}

@Component({
  components: {
    BottomWrapper,
  },
  directives: {
    waiting,
  },
})
export default class LoggedInForm extends Vue {
  @Prop({ default: '' }) readonly issueMsg!: '';
  @Prop({ default: '' }) readonly subject!: string;
  @Prop(Boolean) readonly showBack!: boolean;
  @Prop() readonly connectConfig!: ConnectToAgent | null;
  @Prop({ default: null }) readonly loggedInFormSavedData!: VisitorInfoFilled | null;

  @userModule.State('phone') userPhone!: string;
  @userModule.State('email') userEmail!: string;
  @userModule.Getter('maskName') maskName!: string;
  @userModule.Mutation('setUserPhoneOrEmailIfNotExists') setUserPhoneOrEmailIfNotExists!: (user: { phone?: string, email?: string }) => void;

  loading = false;
  hasEmail = false;

  MAX_DESCRIPTION_CHAR_NUM = MAX_DESCRIPTION_CHAR_NUM;

  get descriptionLength () {
    return this.loggedInForm.description?.length || 0;
  }

  get isDescriptionExceed () {
    return this.descriptionLength > MAX_DESCRIPTION_CHAR_NUM;
  }

  // TODO: change to open request if condition from connect config. Move to trigger ticket creation component after it. Rename component
  get buttons () {
    return [{
      name: this.t('global.proceed', 'Proceed'),
      id: '',
      isActive: true,
    }];
  };
  loggedInForm: TicketForm = {
    email: this.userEmail,
    description: '',
    subject: '',
    name: this.userPhone,
  };
  errors = {
    email: false,
    description: false,
  }

  get staticFormFields (): FormField[] {
    return [
      {
        id: -10000,
        displayName: this.$t('global.description') as string,
        placeholder: this.connectConfig?.descriptionMessage || this.$t('global.describe') as string,
        name: 'description',
        required: true,
      }, {
        id: -10001,
        displayName: this.$t('global.subject') as string,
        placeholder: this.$t('global.subject') as string,
        name: 'subject',
        required: false,
      },
    ];
  }

  apiFormFields: FormField[] = [];

  get allFormFields () {
    return [...this.staticFormFields, ...this.apiFormFields];
  }

  created () {
    document.title = 'Logged In Form';
    this.loading = true;
    // TODO: [Sportybet]

    const formFieldRequest = PleasedApi.getTicketFields().then(res => res.map(f => ({ ...f, required: f.isMandatory, name: f.fieldName })).filter(item => item.name !== 'email'));

    Promise.all([Api.getAccountInfo(), formFieldRequest])
      .then(([res, formFields]) => {
        this.apiFormFields = formFields;
        if (res.bizCode === 10000) {
          res.data.email && this.setUserPhoneOrEmailIfNotExists({ email: res.data.email });
          res.data.phone && this.setUserPhoneOrEmailIfNotExists({ phone: res.data.phone });
        }
        if (res.bizCode === 10000 && res.data.email) {
          this.loggedInForm.email = res.data.email;
          this.hasEmail = true;
        }
      })
      .finally(() => {
        this.loading = false;
      });
    this.loggedInForm.subject = this.subject;

    if (this.loggedInFormSavedData) {
      this.loggedInForm.description = this.loggedInFormSavedData.description;
    }
  }

  validate () {
    let result = true;
    const isDescriptionRequired = !!this.allFormFields.find(item => item.name === 'description' && item.required === true);
    const isEmailRequired = !!this.allFormFields.find(item => item.name === 'email' && item.required === true);

    if (
      isDescriptionRequired &&
      (this.loggedInForm.description !== undefined &&
        (this.descriptionLength <= MIN_DESCRIPTION_CHAR_NUM || this.isDescriptionExceed)
      )) {
      this.errors.description = true;
      result = false;
    }
    if (
      isEmailRequired &&
      !isEmailValid(this.loggedInForm.email)
    ) {
      this.errors.email = true;
      result = false;
    }
    return result;
  }

  fillDetail () {
    this.loggedInForm.name = this.maskName;
    const fieldData = this.allFormFields.map(item => {
      if (item.name === 'description' && this.issueMsg) {
        const description = `${this.loggedInForm[item.name.toLowerCase() as keyof TicketForm]}` || 'title not handled';
        const value = combinedDescription(description, this.issueMsg);
        return {
          key: item.name,
          value,
          id: item.id,
        };
      }
      if ((item.name || '').trim().toLowerCase() === 'email' && !this.loggedInForm.email) { return { id: item.id, key: item.name, value: this.userEmail }; }
      return {
        id: item.id,
        key: item.name,
        value: item.name === 'phone'
          ? this.userPhone
          : this.loggedInForm[item.name.toLowerCase() as keyof TicketForm] || 'title not handled',
      };
    });
    if (!this.validate()) {
      return;
    }
    const event: VisitorInfoFilled & DynamicFieldData = {
      visitorInfo: {
        displayName: this.loggedInForm.name,
        email: this.loggedInForm.email || '',
        isGuest: false,
      },
      fields: fieldData,
      description: this.loggedInForm.description || '',
    };
    this.$emit('fillDetail', event);
  }
}
